import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import ButtonDialog from "@/components/ButtonDialog.vue";
import BatterTableDataView from "@/components/BatterTableDataView.vue";
import api from "@/api";
import { ElLoading } from "element-plus";
import DialogView from "@/components/DialogView.vue";
export default {
  name: "MergeModeView",
  components: {
    DialogView,
    BatterTableDataView,
    ButtonDialog
  },
  data() {
    return {
      batchSelected: [],
      batchEditVisible: false
    };
  },
  methods: {
    batchEdit() {
      this.batchEditVisible = true;
    },
    updateBatch(d) {
      let loading = ElLoading.service({
        lock: true,
        text: '更新中...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let data = {
        update: d,
        ids: this.batchSelected
      };
      api.batchUpdateMerged(data).then(() => {
        this.batchEditVisible = false;
        this.$refs.ptable.fetchData();
      }).finally(() => {
        loading.close();
      });
    },
    batchDelete() {
      let loading = ElLoading.service({
        lock: true,
        text: '删除中...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      api.batchDeleteMerged({
        uids: this.batchSelected
      }).then(() => {
        loading.close();
        this.$refs.ptable.fetchData();
      });
    },
    onRowSelectChange(rows) {
      this.batchSelected = rows.map(r => r.id);
    },
    deleteAll() {
      let loading = ElLoading.service({
        lock: true,
        text: '删除中...',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      api.deleteAllMergedInfo().then(() => {
        loading.close();
        this.$refs.ptable.fetchData();
      });
    },
    init() {}
  },
  mounted() {
    this.init();
  }
};